// Build a wa.me URL from a free-form phone number (with or without "+", spaces, dashes).
export function whatsappLink(num) {
  if (!num) return null;
  const digits = String(num).replace(/\D/g, "");
  if (digits.length < 6) return null;
  return `https://wa.me/${digits}`;
}

// Display a phone number nicely (just trim).
export function formatPhone(num) {
  if (!num) return "";
  return String(num).trim();
}
